// src/v2/pages/Insights/insightsIcons.tsx
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";

export const PendenciasIcon = DescriptionOutlinedIcon;
export const SearchCpfIcon = SearchOutlinedIcon;
export const PerformanceIcon = BarChartOutlinedIcon;
export const AnomaliasIcon = WarningAmberOutlinedIcon;
export const UltimaExportacaoIcon = CloudDoneOutlinedIcon;
export const ExecutivoIcon = TaskAltOutlinedIcon;
